import { Field, FieldType } from "../types";
import React from "react";
import { EmailAutocomplete } from "./EmailAutocomplete";
import { RadioGroup } from "./RadioGroup";
import { Text } from "./Text";

export const FormField = (field: Field) => {
    const { type } = field;

    switch (type) {
        case FieldType.TEXT:
            return <Text field={field} />;
        case FieldType.RADIO: {
            return <RadioGroup field={field} />;
        }
        case FieldType.EMAIL_AUTOCOMPLETE: {
            return <EmailAutocomplete field={field} />;
        }
        default:
            return null;
    }
};
